import { t } from "@impero-com/common/utils/i18n";
import { queryClient } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";

import {
    getGetUsersUserIdControlProgramsQueryKey,
    usePatchUsersUserIdControlPrograms,
} from "api/generated/users/users";

import { invalidateAssignmentCountQuery } from "./useAssignmentCountQuery";

export function useUpdateControlProgramRightsForUserMutation() {
    return usePatchUsersUserIdControlPrograms({
        mutation: {
            onSuccess: async (_response, { userId }) => {
                emitNotification(
                    "success",
                    t("UserManagement_ControlProgramsUpdated")
                );
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey:
                            getGetUsersUserIdControlProgramsQueryKey(userId),
                    }),
                    invalidateAssignmentCountQuery(userId.toString()),
                ]);
            },
        },
    });
}
